import { ReactComponent as MyIcon } from './support-svgrepo-com.svg';

const StartCampaign = () => {
  return (
    // <section className={`ml-5`} id="portfolio">
    //   <div className="container mx-auto mt-8">
    //     <div className="py-4 text-white font-medium lg:columns-3 md:columns-2 sm:columns-1 bg-sky-200/[0.15] bg-clip-border justify-items-center">
    //       {projects
    //         .map((p) => (
    //           <ProjectCard {...p} />
    //         ))}
    //     </div>
    //   </div>
    // </section>
    <div className='mt-[150px]'>
        <div class="justify-center grid grid-cols-4 place-items-center mr-20">
            <div className='text-center font-bold text-[30px]'>Fundraise for...</div>
            <div className="max-w-sm rounded-[12px] shadow-xl bg-slate-50 m-2 py-3">
              <img className="w-full mt-0" src="hospital.jpg"/>
              <h3 className="text-black font-bold leading-9 text-center">Healthcare</h3>
              <div className="flex flex-row h-8 content-center justify-center gap-x-4">
                <button
                  type="button"
                  className="inline-block px-4 py-2.5 bg-sky-400 text-white font-medium text-sm leading-tight uppercase rounded-full shadow-md hover:bg-blue-700"
                  onClick={() => setGlobalState('createModal', 'scale-100')}
                >
                  Start
                </button>
              </div>
            </div>
            <div className="max-w-sm rounded-[12px] shadow-xl bg-slate-50 m-2 py-3">
              <img className="w-full mt-0" src="startup.jpg"/>
              <h3 className="text-black font-bold leading-9 text-center">Startups</h3>
              <div className="flex flex-row h-8 content-center justify-center gap-x-4">
                <button
                  type="button"
                  className="inline-block px-4 py-2.5 bg-sky-400 text-white font-medium text-sm leading-tight uppercase rounded-full shadow-md hover:bg-blue-700"
                  onClick={() => setGlobalState('createModal', 'scale-100')}
                >
                  Start
                </button>
              </div>
            </div>
            <div className="max-w-sm rounded-[12px] shadow-xl bg-slate-50 m-2 py-3">
              <img className="w-full mt-0" src="edu.jpg"/>
              <h3 className="text-black font-bold leading-9 text-center">Education</h3>
              <div className="flex flex-row h-8 content-center justify-center gap-x-4">
                <button
                  type="button"
                  className="inline-block px-4 py-2.5 bg-sky-400 text-white font-medium text-sm leading-tight uppercase rounded-full shadow-md hover:bg-blue-700"
                  onClick={() => setGlobalState('createModal', 'scale-100')}
                >
                  Start
                </button>
              </div>
            </div>
        </div>
    </div>
  );
};

export default StartCampaign;
